import axios from "axios";

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BETTEREZ_BASE_URL + "/notifications/",
  responseType: "blob",
  headers: {
    "x-api-key": process.env.VUE_APP_BETTEREZ_X_API_KEY,
  },
});
export default {
  getPrintedTickets(transactionId) {
    return HTTP.get("printed-tickets", {
      params: {
        trxId: transactionId,
        channel: "websales",
      },
    });
  },
  sendOrderEmail(transactionId, language) {
    return HTTP.post("email", null, {
      params: {
        trxId: transactionId,
        lang: language,
        channel: "websales",
      },
    });
  },
};
